<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-stately/select';
import {ClassAPI, HeaderInfo, TypeContext, FunctionAPI, TypeLink} from '@react-spectrum/docs';
import packageData from '@react-stately/select/package.json';

---
category: Forms
keywords: [select, state]
---

# useSelectState

<p>{docs.exports.useSelectState.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['useSelectState']} />

## API

<FunctionAPI function={docs.exports.useSelectState} links={docs.links} />

## Interface

<ClassAPI links={docs.links} class={docs.links[docs.exports.useSelectState.return.base.id]} />

## Example

See the docs for [useSelect](/react-aria/useSelect.html) in react-aria for an example of `useSelectState`.
